export const BorderColorStyle = { property:'BorderColor', styleProperty: 'border-color'}
export const BackgroundColorStyle = { property:'BackgroundColor', styleProperty: 'background-image'}
export const TextColorStyle = { property:'TextColor', styleProperty: 'color'}
